import type { FC } from "react";
import { useEffect, useState } from "react";

import { ResponsiveImage } from "@ui/components/ResponsiveImage";
import { useTranslations } from "@ui/providers/useTranslations";
import classNames from "classnames";

type FlavorFinderResultSuggestionCardProps = {
  description: string;
  imgUrl: string;
  onSelectionChange: (value: string) => void;
  useResultsWithDeviceLink: string;
};

export const FlavorFinderResultSuggestionCard: FC<FlavorFinderResultSuggestionCardProps> = ({
  description,
  imgUrl,
  onSelectionChange,
  useResultsWithDeviceLink,
}) => {
  const [gradientBackground, setGradientBackground] = useState("");
  const { __ } = useTranslations();

  useEffect(() => {
    setGradientBackground(`linear-gradient(291deg, #2D2926 1.61%, #3A393B 98.69%)`);
  }, []);

  const [selectedOption, setSelectedOption] = useState<string>(useResultsWithDeviceLink);

  useEffect(() => {
    onSelectionChange(selectedOption);
  }, [selectedOption, onSelectionChange]);

  const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setSelectedOption(newValue);
    onSelectionChange(newValue);
  };

  return (
    <div className={classNames("flavorfinder__result flavorfinder__result--suggested-device")}>
      <div
        className="flavorfinder__result-suggestion-card"
        data-testid="flavor-finder-result-suggesgted-device"
        style={{ background: gradientBackground }}
      >
        <div className={"flavorfinder__result-card-image"}>
          <ResponsiveImage largeSrc={imgUrl} />
        </div>
        <div className="flavorfinder__result-card-text">
          <p className="flavorfinder__result-card-title">{description}</p>
          <div className="flavorfinder__inputs">
            <div className="flavorfinder__input-wrapper">
              <input
                type="radio"
                id="suggested-device-yes"
                data-testid="suggested-device-yes"
                name="answerGroup"
                value="yes"
                checked={selectedOption === "yes"}
                onChange={handleOptionChange}
              />
              <label htmlFor="suggested-device-yes">{__("flavorfinder.general.yes")}</label>
            </div>
            <div className="flavorfinder__input-wrapper">
              <input
                type="radio"
                id="suggested-device-no"
                data-testid="suggested-device-no"
                name="answerGroup"
                value="no"
                checked={selectedOption === "no"}
                onChange={handleOptionChange}
              />
              <label htmlFor="suggested-device-no">{__("flavorfinder.general.no")}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
